var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex justify-center items-center",class:[{ 'p-0.5 bg-upgrade rounded-full': _vm.contained }, _vm.size]},[_c('Iconic',{class:_vm.contained ? 'w-full h-full text-white' : 'w-full h-full text-upgrade',attrs:{"slug":"crown"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }